import React from "react"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"

const SubheaderFinance = ({ title, price, link }) => (
  <header className="subheader">
    <div className="subheader__container">
      <div className="subheader__title t6">{title}</div>
      <div className="subheader__price t6">{price}</div>
      <OutboundLink href={link} className="subheader__cta cta cta--tiny t5">
        Learn More
      </OutboundLink>
    </div>
  </header>
)

SubheaderFinance.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default SubheaderFinance
